import { forwardRef, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  mono?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", mono = false, ...rest }, ref) => (
    <input
      ref={ref}
      className={`w-full h-11 px-3.5 bg-transparent border-b border-[var(--ink)] text-[var(--ink)] placeholder:text-[var(--ink-4)] focus:border-b-2 focus:pb-[3px] focus:outline-none transition-colors ${mono ? "mono text-[13px]" : "sans text-[14px]"} ${className}`}
      {...rest}
    />
  ),
);
Input.displayName = "Input";
